import React, { useState } from 'react'
import { Collapse, List, ListItemButton } from '@mui/material'

import Icon from 'components/icon'
import { useI18next } from 'gatsby-plugin-react-i18next'
import { getLocaleName } from 'utils/i18n'

const CollapseListSwitcher = () => {
  const { language, languages, changeLanguage } = useI18next()

  const [collapseState, setCollapseState] = useState(false)

  const toggleListItem = () => {
    setCollapseState(!collapseState)
  }

  return (
    <List classes={{ root: 'py-0' }}>
      <ListItemButton classes={{ root: 'flex items-center px-4' }} onClick={toggleListItem}>
        <Icon name="language_outlined" className="text-gray-700" />
        <span className="font-bold pl-1 text-sm text-gray-700">{getLocaleName(language)}</span>
      </ListItemButton>
      <Collapse in={collapseState} timeout="auto">
        <List>
          {languages.map((lang) => {
            return lang === language ? null : (
              <ListItemButton
                key={lang}
                classes={{ root: 'px-10 text-gray-700 text-sm' }}
                onClick={(e) => {
                  e.preventDefault()
                  changeLanguage(lang)
                }}
              >
                {getLocaleName(lang)}
              </ListItemButton>
            )
          })}
        </List>
      </Collapse>
    </List>
  )
}

export default CollapseListSwitcher
